<template>
  <div class="selectCertTemplate">
    <el-dialog title="选择模板"
             :close-on-click-modal="false"
             :show-close="true"
             :visible.sync="visible"
             width="70%"
             :before-close="dialogClose">
      <div style="height: 600px;">
      <el-card shadow="never"
               class="aui-card--fill">
        <el-form label-position="left"
                 label-width="auto"
                 :model="dataForm">
          <el-row class="margb10">
            <el-col :span="12" style="margin-right: 29.1%;">
              <el-form-item :label="$t('cert.templateName')">
                <el-input v-model="dataForm.templateName"
                          :placeholder="$t('cert.keyword')"
                          onkeydown="if (event.keyCode===13){return false;}"
                          clearable></el-input>
                </el-form-item>
            </el-col>
            <!-- <el-col :span="7">
              <el-form-item :label="$t('cert.certYear')"
                            prop="certYear">
                <el-select v-model="dataFormHold.certYearArr"
                           multiple
                           collapse-tags
                           :placeholder="$t('cert.select')">
                  <el-option v-for="(item,index) in certYearArrs"
                             :key="index"
                             :label="item"
                             :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="5">
              <el-button style="margin-bottom: 7px" class="M-search" @click="queryTemplate()" type="primary">{{ $t('query') }}</el-button>
            </el-col>
          </el-row>
          <el-row class="margb10">
            <el-col :span="5">
              <el-button type="primary" class="M-search" @click="templateOk">{{$t('confirm')}}</el-button>
            </el-col>
            <el-col :span="14">&nbsp;</el-col>
            <el-col :span="5">
              <el-button class="el-back M-search M-margin-l" type="info" @click="resetQuery">{{$t('reset')}}</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-table v-loading="dataListLoading"
                  :data="dataList"
                  border
                  @selection-change="selectTemplate"
                  style="width: 100%;"
                  ref="selectTemplateinfo"
                  height="350">
          <el-table-column type="selection"
                          header-align="center"
                          align="center"
                          width="50"></el-table-column>
          <el-table-column prop="certTmplId"
                          :label="$t('cert.templateNo')"
                          header-align="center"
                          v-if="false"
                          align="left"></el-table-column>
          <el-table-column prop="pdfUrl"
                          :label="$t('cert.templateNo')"
                          header-align="center"
                          v-if="false"
                          align="left"></el-table-column>
          <el-table-column prop="certTmplNo"
                          :label="$t('cert.templateNo')"
                          header-align="center"
                          align="left"
                          show-overflow-tooltip></el-table-column>
          <el-table-column prop="certTmplName"
                          :label="$t('cert.templateName')"
                          header-align="center"
                          align="left"
                          show-overflow-tooltip></el-table-column>
          <!--创建时间-->
          <el-table-column prop="creatDateStr"
                           :label="$t('cert.createDate')"
                           header-align="center"
                           align="center"
                           width="150"
                           show-overflow-tooltip></el-table-column>
          <el-table-column class="link-type"
                           header-align="center"
                           align="center">
            <template slot-scope="scope">
              <!-- <el-link :href="scope.row.pdfUrl + scope.row.certTmplNo" target="_blank">预览</el-link> -->
              <el-button size="mini"
                         type="text"
                         @click="preview(scope.row)">{{$t('cert.preview')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page="page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="limit"
                       :total="total"
                       layout="total, sizes, prev, pager, next, jumper"
                       @size-change="pageSizeChangeHandle"
                       @current-change="pageCurrentChangeHandle">
        </el-pagination>
      </el-card>
      </div>
    </el-dialog>
    <!--证书模板选择子画面-->
    <certTemplatePreview v-bind:visible="templatePreviewDialog"
                     v-bind:url="templateUrl"
                     ref="templatePreviewDialogRef"
                     v-on:templatePreviewOk="templatePreviewOk"
                     @func="passByValueFunc"></certTemplatePreview>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import certTemplatePreview from './certTemplatePreview'
import Vue from 'vue'
export default {
  mixins: [mixinViewModule],
  name: 'selectCertTemplate',
  components: { certTemplatePreview },
  data () {
    return {
      mixinViewModuleOptions: {
        activatedIsNeed: false,
        getDataListURL: '/learning/certinfo/queryCertTemplateList',
        getDataListIsPage: true,
        deleteURL: '/learning/certinfo/deleteCertTemplate',
        deleteIsBatch: true
      },
      dataForm: {
        templateName: '',
        certYear: ''
      },
      dataFormHold: {
        certYearArr: []
      },
      // 等待转圈
      dataListLoading: false,
      // certYearArrs: [],
      templatePreviewDialog: false,
      templateUrl: {},
      pdfUrl: `${window.SITE_CONFIG['apiURL']}/learning/certinfo/previewCertTmpl?token=${this.getStorage(this.GLOBAL.TOKEN)}&certTmplNo=`
    }
  },
  props: {
    visible: {// 是否显示
      type: Boolean,
      required: false,
      default: false
    },
    certYearList: {// 认证获得年List
      type: Array,
      required: true
    },
    certYear: {// 当前认证获得年
      type: String,
      required: false
    }
  },
  methods: {
    initMethods () {
      this.visible = true
      this.resetQuery()
      if (this.certYearList) {
        this.certYearArrs = this.certYearList
      }
      if (this.certYear && this.certYear !== null) {
        this.dataFormHold.certYearArr.push(this.certYear)
      }
      this.queryTemplate()
    },
    dialogClose (done) {
      this.$emit('templateOk')
      // done()
    },
    // 查询
    queryTemplate () {
      let _this = this
      _this.page = 1
      // if (this.dataFormHold.certYearArr instanceof Array) {
      //   this.dataForm.certYear = this.dataFormHold.certYearArr.join(',')
      // }
      _this.getDataList()
    },
    selectTemplate (selection) {
      if (selection.length > 1) {
        this.$refs.selectTemplateinfo.clearSelection()
        this.$refs.selectTemplateinfo.toggleRowSelection(selection.pop())
      }
    },
    // 重置查询条件
    resetQuery () {
      this.dataForm = {
        templateName: '',
        certYear: ''
      }
      this.dataFormHold = {
        certYearArr: []
      }
      this.getDataList()
    },
    templateOk () {
      let select = this.$refs.selectTemplateinfo.selection
      if (select.length <= 0) {
        this.$message.warning(this.$t('cert.pleaseSelectTemplate'))
        return false
      }
      this.$emit('templateOk', select[0])
    },
    add0(m) {
      return m < 10 ? '0' + m : m
    },
    // 预览
    preview (row) {
      console.log(row)
      // let url = ''
      // let param = ''
      // url = '/learning/certinfo/previewCertTmpl'
      // param = {
      //   certTmplNo: row.certTmplNo
      // }
      // this.$request.downloadPDF(
      //   url,
      //   'aaa',
      //   param
      // )
      // let companyFirstTitle = ''
      // console.log(row.companyFirst.indexOf("/"))

      let time = new Date();
      let y = time.getFullYear() + row.expireTime,
          m = time.getMonth() + 1,
          d = time.getDate();
      row.effectiveDate = y + '-' + this.add0(m) + '-' + this.add0(d)

      if(row.companyFirst !== null) {
        if(row.companyFirst.indexOf("/") !== -1) {
          row.companyFirstChinese = row.companyFirst.substring(0, row.companyFirst.indexOf("/"))
          row.companyFirstEnglish = row.companyFirst.substring(row.companyFirst.indexOf("/") + 1, row.companyFirst.length)
        } else {
          row.companyFirstChinese = row.companyFirst
          row.companyFirstEnglish = ""
        }
      }
      
      this.templateUrl = row
      console.log(typeof this.templateUrl)
      this.templatePreviewDialog = true
    },
    passByValueFunc(data) {
      console.log(data)
      this.templatePreviewDialog = 'false'
    },
    templatePreviewOk () {
      this.templatePreviewDialog = false
    },
    // 获取数据列表
    getDataList () {
      let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
      if ('regionIds' in newDataForm) {
        if (newDataForm.regionIds.length === 0) {
          newDataForm.regionIds = ''
        } else {
          newDataForm.regionIds = newDataForm.regionIds.join(',')
        }
      }
      this.dataListLoading = true
      this.$request.get(
        this.mixinViewModuleOptions.getDataListURL,
        {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
          ...newDataForm
        }
      ).then((res, total, code, data) => {
        console.log(data)
        this.pdfUrl= `${window.SITE_CONFIG['apiURL']}/learning/certinfo/previewCertTmpl?token=${this.getStorage(this.GLOBAL.TOKEN)}&certTmplNo=`
        this.dataListLoading = false
        let resultList = data.data.records
        this.dataList = !this.mixinViewModuleOptions.getDataListIsPage ? data.data : resultList
        for (var i = 0; i < this.dataList.length; i++) {
          this.dataList[i].pdfUrl = this.pdfUrl
        }
        // this.dataList = resultList
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? data.data.total : 0
      }).catch(() => {
        this.dataListLoading = false
      })
    }
  }
}
</script>
<style>
.selectCertTemplate thead .el-table-column--selection .cell {
  display: none !important;
}
</style>
